.wrap {
  margin-top: 10px;
  margin-bottom: 10px;
}

.hint {
  font-size: 12px;
  color: var(--muted2);
  margin-bottom: 8px;
  line-height: 1.5;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  display: inline-flex;
  align-items: center;
  background: var(--blue-lt);
  border: 1px solid var(--blue-mid);
  border-radius: 16px;
  padding: 4px 11px;
  font-size: 13.5px;
  color: var(--blue);
}

.expandBtn {
  display: inline-flex;
  align-items: center;
  padding: 4px 11px;
  background: none;
  border: 1px dashed var(--border);
  border-radius: 16px;
  font-size: 13px;
  color: var(--blue);
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  transition: border-color .15s, background .15s;
}

.expandBtn:hover {
  border-color: var(--blue);
  background: var(--blue-lt);
}
